import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrTrashIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M6 11.6V7.7C6 7.3 6.3 7 6.7 7C7.1 7 7.4 7.3 7.4 7.7V11.6C7.4 12 7.1 12.3 6.7 12.3C6.3 12.3 6 12 6 11.6ZM9.7 12.3C10.1 12.3 10.4 12 10.4 11.6V7.7C10.4 7.3 10.1 7 9.7 7C9.3 7 9 7.3 9 7.7V11.6C9 12 9.3 12.3 9.7 12.3ZM15 3.6C15 4 14.7 4.3 14.3 4.3H13.9V14C13.9 14.9 13.1 15.7 12.2 15.7H3.7C2.8 15.7 2 14.9 2 14V4.3H1.7C1.3 4.3 1 4 1 3.6C1 3.2 1.3 2.9 1.7 2.9H4.4C4.4 2.8 4.4 2.8 4.4 2.7L4.7 1.7C4.9 1.3 5.3 1 5.7 1H10.3C10.7 1 11.1 1.3 11.2 1.7L11.5 2.7C11.5 2.8 11.5 2.8 11.5 2.9H14.2C14.7 2.9 15 3.2 15 3.6ZM5.9 2.6H10V2.4H6L5.9 2.6ZM12.5 4.3H3.4V14C3.4 14.2 3.5 14.3 3.7 14.3H12.2C12.4 14.3 12.5 14.2 12.5 14V4.3Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrTrashIconComponent;
